<template>
 <!-- eslint-disable vue/no-mutating-props -->
 <BasicFormWrapper v-if="visible" class="mb-25">
  <sdCards :title="title">
   <a-skeleton v-if="loadingProduct" active/>
   <a-form v-else :model="form" layout="vertical" @finish="$emit('save')">
    <a-row :gutter="30">
     <a-col :sm="8" :xs="24" class="mb-25">
      <a-form-item extra="Leeg laten betekent: geen marketingmail versturen." label="Afzender"
                   name="marketingEmailSenderID">
       <a-select v-model:value="form.marketingEmailSenderID" :allowClear="true"
                 :disabled="!canUpdate" :show-search="true"
                 class="sDash_fullwidth-select" option-filter-prop="label" size="large">
        <a-select-option v-for="(item,index) in senders"
                         :key="index" :label="item.name" :value="item.id" name="marketingEmailSenderID">
         {{ item.name }}
        </a-select-option>
       </a-select>
      </a-form-item>
     </a-col>
     <a-col :sm="8" :xs="24" class="mb-25">
      <a-form-item extra="Verplicht: zonder template wordt er niets verstuurd." label="E-mailtemplate"
                   name="marketingEmailTemplateID">
       <a-select v-model:value="form.marketingEmailTemplateID" :allowClear="true"
                 :disabled="!canUpdate" class="sDash_fullwidth-select" size="large">
        <a-select-option v-for="(item,index) in emailTemplates"
                         :key="index" :value="item.id" name="marketingEmailTemplateID">
         {{ item.name }}
        </a-select-option>
       </a-select>
      </a-form-item>
     </a-col>
     <a-col :sm="8" :xs="24" class="mb-25">
      <a-form-item extra="Verplicht: zonder onderwerp wordt er niets verstuurd." label="Onderwerp"
                   name="marketingEmailSubject">
       <a-input v-model:value="form.marketingEmailSubject" :disabled="!canUpdate" placeholder="" size="large"/>
      </a-form-item>
     </a-col>
    </a-row>
    <a-row v-if="standardQuoteTemplateOptions.length > 0" :gutter="30">
     <a-col :sm="24" :xs="24">
      <p class="mb-10">
       Bijgesloten PDF per antwoord op &quot;{{ interestQuestionLabel }}&quot;
      </p>
     </a-col>
     <a-col v-for="quoteTemplate in standardQuoteTemplateOptions" :key="quoteTemplate.key" :sm="8" :xs="24"
            class="mb-25">
      <a-form-item :label="quoteTemplate.label" :name="['standardQuoteTemplateIDs', quoteTemplate.key]">
       <a-select v-model:value="form.standardQuoteTemplateIDs[quoteTemplate.key]" :allowClear="true"
                 :disabled="!canUpdate" class="sDash_fullwidth-select" size="large">
        <a-select-option v-for="(item,index) in pdfTemplates"
                         :key="index" :value="item.id"
                         :name="['standardQuoteTemplateIDs', quoteTemplate.key]">
         {{ item.name }}
        </a-select-option>
       </a-select>
      </a-form-item>
     </a-col>
    </a-row>
    <a-row>
     <a-col :sm="12" :xs="24">
      <div class="sDash_form-action">
       <a-button v-if="canUpdate" :disabled="saving" :loading="saving" class="btn-signin"
                 html-type="submit" size="large" type="primary">
        Opslaan
       </a-button>
      </div>
     </a-col>
    </a-row>
   </a-form>
  </sdCards>
 </BasicFormWrapper>
</template>

<script>
import {computed, watch} from 'vue';
import {BasicFormWrapper} from '@/view/styled';

export default {
 name: 'ProductEplatformSettings',
 components: {
  BasicFormWrapper,
 },
 props: {
  form: {
   type: Object,
   required: true,
  },
  loadingProduct: {
   type: Boolean,
   default: false,
  },
  saving: {
   type: Boolean,
   default: false,
  },
  canUpdate: {
   type: Boolean,
   default: false,
  },
  pdfTemplates: {
   type: Array,
   default: () => [],
  },
  emailTemplates: {
   type: Array,
   default: () => [],
  },
  senders: {
   type: Array,
   default: () => [],
  },
  interestOptions: {
   type: Array,
   default: () => [],
  },
  interestQuestionLabel: {
   type: String,
   default: 'productinteresse',
  },
 },
 emits: ['save'],
 setup(props) {
  const visible = computed(() => props.form?.type === 'SUSTAINABILITYCONSULTATION');

  const title = 'Marketingmail';

  // De keuzes van de flowvraag 'Welk product heeft u het meest interesse in?'
  // bepalen waarop gemapt wordt; het antwoord van de klant is exact deze tekst.
  const standardQuoteTemplateOptions = computed(() => props.interestOptions
   .filter((option) => typeof option === 'string' && option.trim() !== '')
   .map((option) => ({key: option, label: option})));

  watch(() => [props.form?.type, props.form?.standardQuoteTemplateIDs, props.interestOptions], () => {
   if (!props.form) {
    return;
   }

   const huidig = props.form.standardQuoteTemplateIDs;
   const geldig = huidig !== null && typeof huidig === 'object' && !Array.isArray(huidig);

   // Bestaande sleutels blijven staan: een oude mapping mag niet verdwijnen
   // doordat een keuze is hernoemd.
   const mapping = geldig ? {...huidig} : {};
   const ontbreekt = standardQuoteTemplateOptions.value.filter(({key}) => !(key in mapping));
   ontbreekt.forEach(({key}) => {
    mapping[key] = null;
   });

   if (!geldig || ontbreekt.length > 0) {
    Object.assign(props.form, {standardQuoteTemplateIDs: mapping});
   }
  }, {immediate: true});

  return {
   visible,
   title,
   standardQuoteTemplateOptions,
  };
 },
};
</script>
